import { render, staticRenderFns } from "./uf_sum_request.vue?vue&type=template&id=3fa461b1&scoped=true"
import script from "./uf_sum_request.vue?vue&type=script&lang=js"
export * from "./uf_sum_request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa461b1",
  null
  
)

export default component.exports